<template>
  <div class="header-block">
    <div class="front-slider">
      <swiper ref="swiper" class="front-slider-wrapper" :options="swiperOptions" @slideChange="updateCurrentSlide">
        <swiper-slide class="front-slide">
          <div class="container">
            <div class="content">
              <div class="left">
                <img src="./images/Header-title-1-SVG.svg">
                <p>Welcome to TRUE WORLD — a place where your dreams meet technology, and you are the hero of an extraordinary journey. The Web3 universe is ready for you to take center stage.</p>
              </div>
              <div class="right">
                <p>Welcome to TRUE WORLD — a place where your dreams meet technology, and you are the hero of an extraordinary journey. The Web3 universe is ready for you to take center stage.</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="front-slide">
          <div class="container">
            <div class="content">
              <div class="left">
                <img src="./images/Header-title-2-SVG.svg">
              </div>
              <div class="right">
                <p>Every game in TRUE World is a portal to&nbsp;a&nbsp;unique universe, a&nbsp;living&nbsp;chapter in an&nbsp;ever-evolving saga. Each spin&nbsp;isn’t just a wager; it’s a step into&nbsp;a&nbsp;larger story&nbsp;where fortunes rise, mysteries unfold, and legends are forged.</p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="front-slide">
          <div class="container">
            <div class="content">
              <div class="left">
                <img src="./images/Header-title-3-SVG.svg">
                <p>More than just a gaming platform, TRUE World is a <span>new way to play&nbsp;and&nbsp;earn</span>. Players don’t just participate — <span>they own, evolve, and&nbsp;leave&nbsp;their&nbsp;mark</span>.</p>
              </div>
              <div class="right">
                <div>
                  <img src="./images/web3-icon-1.png">
                  <div class="text">
                    <strong>Engaging Gameplay</strong>
                    <p>Players earn in-game currency,  compete in tournaments, complete quests,  and customize avatars.</p>
                    <p class="mobile">Tournaments, quests, and customizable avatars.</p>
                  </div>
                </div>
                <div>
                  <img src="./images/web3-icon-2.png">
                  <div class="text">
                    <strong>Real Rewards</strong>
                    <p>Players earn real-world assets (RWAs), NFTs,  and tokenized rewards that hold lasting value.</p>
                    <p class="mobile">Real-world assets, NFTs, and tokenized rewards.</p>
                  </div>
                </div>
                <div>
                  <img src="./images/web3-icon-3.png">
                  <div class="text">
                    <strong>Responsible Design</strong>
                    <p>AI-driven mechanics promote healthy  gaming habits, preventing exploitative play.</p>
                    <p class="mobile">AI-driven mechanics promote healthy gaming habits.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="front-slide">
          <div class="container">
            <div class="content">
              <div class="left">
                <img src="./images/Header-title-4-SVG.svg">
                <p>We provide stakeholders with real-time access to our ecosystem's performance metrics through Dune Analytics:</p>
                <div class="buttons">
                  <a href="https://dune.com/trueworld/truegames" target="_blank">
                    TRUE Games

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.4">
                        <path d="M1.13128 11.6313C0.789573 11.973 0.789573 12.527 1.13128 12.8687C1.47299 13.2104 2.02701 13.2104 2.36872 12.8687L1.13128 11.6313ZM13.125 1.75C13.125 1.26675 12.7332 0.875 12.25 0.875L4.375 0.874999C3.89175 0.875 3.5 1.26675 3.5 1.75C3.5 2.23325 3.89175 2.625 4.375 2.625L11.375 2.625L11.375 9.625C11.375 10.1082 11.7668 10.5 12.25 10.5C12.7332 10.5 13.125 10.1082 13.125 9.625L13.125 1.75ZM2.36872 12.8687L12.8687 2.36872L11.6313 1.13128L1.13128 11.6313L2.36872 12.8687Z" fill="white"/>
                      </g>
                    </svg>
                  </a>
                  <a href="https://dune.com/trueworld/truecoin">
                    TRUE World

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.4">
                        <path d="M1.13128 11.6313C0.789573 11.973 0.789573 12.527 1.13128 12.8687C1.47299 13.2104 2.02701 13.2104 2.36872 12.8687L1.13128 11.6313ZM13.125 1.75C13.125 1.26675 12.7332 0.875 12.25 0.875L4.375 0.874999C3.89175 0.875 3.5 1.26675 3.5 1.75C3.5 2.23325 3.89175 2.625 4.375 2.625L11.375 2.625L11.375 9.625C11.375 10.1082 11.7668 10.5 12.25 10.5C12.7332 10.5 13.125 10.1082 13.125 9.625L13.125 1.75ZM2.36872 12.8687L12.8687 2.36872L11.6313 1.13128L1.13128 11.6313L2.36872 12.8687Z" fill="white"/>
                      </g>
                    </svg>
                  </a>
                  <a href="https://dune.com/trueworld/true-app">
                    TRUE Wallet

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.4">
                        <path d="M1.13128 11.6313C0.789573 11.973 0.789573 12.527 1.13128 12.8687C1.47299 13.2104 2.02701 13.2104 2.36872 12.8687L1.13128 11.6313ZM13.125 1.75C13.125 1.26675 12.7332 0.875 12.25 0.875L4.375 0.874999C3.89175 0.875 3.5 1.26675 3.5 1.75C3.5 2.23325 3.89175 2.625 4.375 2.625L11.375 2.625L11.375 9.625C11.375 10.1082 11.7668 10.5 12.25 10.5C12.7332 10.5 13.125 10.1082 13.125 9.625L13.125 1.75ZM2.36872 12.8687L12.8687 2.36872L11.6313 1.13128L1.13128 11.6313L2.36872 12.8687Z" fill="white"/>
                      </g>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="dots">
        <div v-for="i of 4" class="dot" :class="{'active': currentSlide === i-1}" @click="goTo(i-1)"></div>
      </div>
    </div>

    <div class="cta">
      <span>New here?</span>
      <a href="#" @click.prevent="loginOrRedirect" class="button button-gradient">Start Playing Now</a>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'header-block',
  components: {
    'swiper': Swiper,
    'swiper-slide': SwiperSlide
  },
  data() {
    return {
      currentSlide: -1
    }
  },
  computed: {
    swiperOptions() {
      return {
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
      }
    },
  },
  methods: {
    goTo(id) {
      this.$refs.swiper.$swiper.slideTo(id)
    },
    loginOrRedirect() {
      if (this.$store.state.isGuest) {
        window.location.hash = '#/login/'
      } else {
        this.$router.push("/test")
      }
    },
    updateCurrentSlide() {
      this.currentSlide = this.$refs.swiper.$swiper.activeIndex;
    }
  },
  mounted() {
    this.currentSlide = 0;
  }
}
</script>

<style lang="less" scoped>
  .header-block {
    > .front-slider {
      position: relative;
      display: flex;
      height: 740px;
      overflow: hidden;

      > .dots {
        position: absolute;
        bottom: 81px;
        left: calc((100vw - 1180px) / 2);
        display: flex;
        gap: 10px;
        z-index: 2;

        > .dot {
          position: relative;
          width: 50px;
          height: 2px;
          background: transparent;
          border-radius: 10px;
          cursor: pointer;
          padding-bottom: 9px;

          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            width: 100%;
            height: 2px;
            background: rgba(255, 255, 255, .3);
            transition: 0s;
          }

          &:after {
            content: '';
            position: absolute;
            left: auto;
            right: 0;
            top: 0;
            display: block;
            width: 0;
            height: 2px;
            background: #FFF;
            transition: 300ms;
            z-index: 2;
          }

          &.active {
            &:after {
              left: 0;
              right: auto;
              width: 100%;
              transition: all 3000ms ease;
            }
          }
        }
      }

      > .front-slider-wrapper {
        .front-slide {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          width: 100%;
          height: 740px;
          padding-bottom: 90px;
          background-position: top center;
          background-size: 2560px;
          background-repeat: no-repeat;

          &:nth-child(1) {
            background-image: url("./images/Header-bg-image-1.jpg");
          }

          &:nth-child(2) {
            background-image: url("./images/Header-bg-image-2.jpg");
          }

          &:nth-child(3) {
            background-image: url("./images/Header-bg-image-3.jpg");
            > .container > .content {
              gap: 83px;
            }
            > .container > .content > .left {
              width: 710px;
              display: flex;
              justify-content: flex-end;
              flex-direction: column;

              > img {
                margin-bottom: 40px;
              }
              > p {
                display: block;
                font-family: Poppins;
                font-weight: 500;
                font-size: 18px;
                line-height: 30px;
                color: #FFF;
                margin-bottom: 78px;
                > span {
                  font-weight: 700;
                  color: #FFF;
                }
              }
            }
            > .container > .content > .right {
              display: flex;
              flex-direction: column;
              gap: 22px;
              padding-bottom: 9px;

              > div {
                display: flex;
                flex-direction: column;
                color: #FFF;
                > img {
                  display: block;
                  width: 72px;
                  margin-bottom: 6px;
                }
                > div {
                  > strong {
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 30px;
                    margin-bottom: 4px;
                  }
                  > p {
                    font-size: 16px;
                    line-height: 24px;
                    padding-right: 50px;
                    &.mobile {
                      display: none;
                    }
                  }
                }
              }
            }
          }

          &:nth-child(4) {
            background-image: url("./images/Header-bg-image-4.jpg");

            > .container > .content > .left {
              width: 710px;
              display: flex;
              justify-content: flex-end;
              flex-direction: column;

              > img {
                margin-bottom: 40px;
              }
              > p {
                display: block;
                font-family: Poppins;
                font-weight: 500;
                font-size: 18px;
                line-height: 30px;
                color: #FFF;
                margin-bottom: 30px;
              }
              > .buttons {
                display: flex;
                gap: 10px;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 78px;
                > a {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 190px;
                  height: 60px;
                  border-radius: 14px;
                  transition: all .2s;
                  color: #fff;
                  font-size: 16px;
                  line-height: 24px;
                  border: 1px solid hsla(0, 0%, 100%, .2);
                  gap: 8px;
                  &:hover {
                    border-color: #fff;
                  }
                }
              }
            }
          }

          > .container {
            > .content {
              display: flex;
              justify-content: space-between;

              > .left {
                > img {
                  margin-bottom: 78px;
                }

                > p {
                  display: none;
                }
              }

              > .right {
                width: 440px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                padding-bottom: 80px;

                > p {
                  font-family: Poppins;
                  font-weight: 500;
                  font-size: 18px;
                  line-height: 30px;
                  color: #FFF;
                }
              }
            }
          }
        }
      }
    }
    > .cta {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        background: #C9D8FF0F;
        padding: 20px 0;
        > span {
          font-family: Poppins;
          font-weight: 500;
          font-size: 20px;
          line-height: 30px;
          color: #FFF;
        }
        > a.button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 236px;
          height: 60px;
          border-radius: 14px;
          background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
          color: #FFF;
          &:hover {
            background: linear-gradient(90deg, #9D5BFF 20%, #563AE7 80%);
          }
        }
      }
  }

  @media screen and (max-width: 1439px) {
    .header-block {
      > .front-slider {
        position: relative;
        display: flex;
        height: 560px;
        overflow: hidden;

        > .dots {
          bottom: 53px;
          left: calc((100vw - 846px) / 2);
          gap: 10px;

          > .dot {
            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 100%;
              height: 2px;
              background: rgba(255, 255, 255, .3);
              transition: 0s;
            }

            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 0;
              height: 2px;
              background: #FFF;
              transition: 0s;
              z-index: 2;
            }

            &.active {
              &:after {
                width: 100%;
                transition: all 3000ms ease;
              }
            }
          }
        }

        > .front-slider-wrapper {
          .front-slide {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 100%;
            height: 560px;
            padding-bottom: 62px;
            background-size: 1938px;

            &:nth-child(1) {
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 452px;
                      margin-bottom: 62px;
                    }
                  }
                }
              }
            }
            &:nth-child(2) {
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 369px;
                      margin-bottom: 48px;
                    }
                  }
                  > .right {
                    padding-bottom: 40px;
                    > p {
                      font-size: 16px;
                      line-height: 26px;
                    }
                  }
                }
              }
            }
            &:nth-child(3) {

              > .container > .content {
                gap: 59px;
              }
              > .container > .content > .left {
                width: 507px;

                > img {
                  width: 507px;
                  margin-bottom: 40px;
                }
                > p {
                  font-size: 16px;
                  line-height: 26px;
                  margin-bottom: 48px;
                }
              }
              > .container > .content > .right {
                width: 280px;
                display: flex;
                flex-direction: column;
                gap: 22px;
                padding-bottom: 0;

                > div {
                  display: flex;
                  flex-direction: row;
                  gap: 14px;
                  color: #FFF;
                  > img {
                    display: block;
                    width: 72px;
                    height: 72px;
                    margin-bottom: 6px;
                  }
                  > div {
                    > strong {
                      font-weight: 700;
                      font-size: 16px;
                      line-height: 30px;
                      margin-bottom: 4px;
                    }
                    > p {
                      font-size: 14px;
                      line-height: 21px;
                      padding-right: 0;
                      &.mobile {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(4) {
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 378px;
                      margin-bottom: 30px;
                    }
                    > p {
                      font-size: 16px;
                      line-height: 26px;
                      margin-bottom: 20px;
                      max-width: 492px;
                    }
                    > .buttons {
                      margin-bottom: 48px;
                      > a {
                        width: 180px;
                        height: 50px;
                        font-size: 14px;
                        line-height: 21px;
                      }
                    }
                  }
                }
              }
            }

            > .container {
              > .content {
                display: flex;
                justify-content: space-between;

                > .left {
                  > img {
                  }

                  > p {
                    display: none;
                    font-size: 16px;
                    line-height: 26px;
                  }
                }

                > .right {
                  width: 334px;
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  padding-bottom: 62px;

                  > p {
                    font-size: 16px;
                    line-height: 26px;
                  }
                }
              }
            }
          }
        }
      }
      > .cta {
        gap: 16px;
        padding: 15px 0;
        > span {
          font-size: 16px;
          line-height: 30px;
        }
        > a.button {
          width: 196px;
          height: 50px;
          border-radius: 12px;
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .header-block {
      > .front-slider {
        position: relative;
        display: flex;
        height: 680px;
        overflow: hidden;

        > .dots {
          bottom: 70px;
          left: calc((100vw - 670px) / 2);
          gap: 10px;

          > .dot {
            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 100%;
              height: 2px;
              background: rgba(255, 255, 255, .3);
              transition: 0s;
            }

            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 0;
              height: 2px;
              background: #FFF;
              transition: 0s;
              z-index: 2;
            }

            &.active {
              &:after {
                width: 100%;
                transition: all 3000ms ease;
              }
            }
          }
        }

        > .front-slider-wrapper {
          .front-slide {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 100%;
            height: 680px;
            padding-bottom: 70px;
            background-size: 1453px;

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 300px;
              display: block;
              width: 100%;
              height: 120px;
              background: linear-gradient(0deg, #010209 0%, rgba(1, 2, 9, 0) 100%);
            }

            &:nth-child(1) {
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 406px;
                    }
                  }
                }
              }
            }
            &:nth-child(2) {
              > .container {
                > .content {
                  flex-direction: column;
                  > .left {
                    > img {
                      width: 334px;
                      margin-bottom: 30px;
                    }
                  }
                  > .right {
                    display: block;
                    padding-bottom: 40px;
                    > p {
                      font-size: 16px;
                      line-height: 26px;
                    }
                  }
                }
              }
            }
            &:nth-child(3) {
              padding-bottom: 112px;

              > .container > .content {
                gap: 52px;
                flex-direction: column;
              }
              > .container > .content > .left {
                width: 100%;

                > img {
                  width: 466px;
                  margin-bottom: 22px;
                }
                > p {
                  font-size: 16px;
                  line-height: 26px;
                  margin-bottom: 0;
                }
              }
              > .container > .content > .right {
                width: 100%;
                display: flex;
                flex-direction: row;
                gap: 22px;
                padding-bottom: 0;

                > div {
                  display: flex;
                  flex-direction: column;
                  gap: 14px;
                  color: #FFF;
                  > img {
                    display: block;
                    width: 72px;
                    height: 72px;
                    margin-bottom: 6px;
                  }
                  > div {
                    > strong {
                      font-weight: 700;
                      font-size: 16px;
                      line-height: 30px;
                      margin-bottom: 4px;
                    }
                    > p {
                      font-size: 14px;
                      line-height: 21px;
                      padding-right: 0;
                      &.mobile {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(4) {
              background-size: 1843px;
              &:before {display: none}
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 378px;
                      margin-bottom: 30px;
                    }
                    > p {
                      font-size: 16px;
                      line-height: 26px;
                      margin-bottom: 20px;
                      max-width: 492px;
                    }
                    > .buttons {
                      margin-bottom: 48px;
                      > a {
                        width: 180px;
                        height: 50px;
                        font-size: 14px;
                        line-height: 21px;
                      }
                    }
                  }
                }
              }
            }

            > .container {
              z-index: 2;
              > .content {
                display: flex;
                justify-content: space-between;

                > .left {
                  > img {
                    margin-bottom: 30px;
                  }

                  > p {
                    display: block;
                    font-family: Poppins;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    color: #FFF;
                    max-width: 520px;
                    margin-bottom: 40px;
                  }
                }

                > .right {
                  display: none;
                }
              }
            }
          }
        }
      }
      > .cta {
        gap: 16px;
        padding: 15px 0;
        > span {
          font-size: 16px;
          line-height: 30px;
        }
        > a.button {
          width: 196px;
          height: 50px;
          border-radius: 12px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .header-block {
      > .front-slider {
        position: relative;
        display: flex;
        height: 458px;
        overflow: hidden;

        > .dots {
          bottom: 38px;
          left: 30px;
          gap: 10px;

          > .dot {
            width: 30px;
            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 100%;
              height: 2px;
              background: rgba(255, 255, 255, .3);
              transition: 0s;
            }

            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 0;
              height: 2px;
              background: #FFF;
              transition: 0s;
              z-index: 2;
            }

            &.active {
              &:after {
                width: 100%;
                transition: all 3000ms ease;
              }
            }
          }
        }

        > .front-slider-wrapper {
          .front-slide {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 100%;
            height: 458px;
            padding-bottom: 38px;
            background-size: 770px;

            &:before {
              display: none;
            }

            &:nth-child(1) {
              background-image: url("./images/Header-bg-image-1-sm.jpg");
              > .container {
                > .content {
                  > .left {
                    > img {
                      width: 228px;
                    }
                  }
                }
              }
            }
            &:nth-child(2) {
              background-image: url("./images/Mobile-Header-bg-image-2.jpg");
              background-size: 770px;
              > .container {
                > .content {
                  flex-direction: column;
                  > .left {
                    > img {
                      width: 187px;
                      margin-bottom: 14px;
                    }
                  }
                  > .right {
                    width: 100%;
                    padding-left: 15px;
                    padding-right: 15px;
                    display: block;
                    padding-bottom: 24px;
                    > p {
                      font-size: 12px;
                      line-height: 20px;
                    }
                  }
                }
              }
            }
            &:nth-child(3) {
              background-image: url("./images/Mobile-Header-bg-image-3.jpg");
              background-size: 770px;
              padding-top: 27px;
              padding-bottom: 64px;
              > .container {
                z-index: 2;
                > .content {
                  display: flex;
                  justify-content: space-between;
                  gap: 0;

                  > .left {
                    padding: 0 15px;
                    > img {
                      width: 265px;
                      margin-bottom: 14px;
                    }

                    > p {
                      font-size: 12px;
                      line-height: 20px;
                      color: #FFF;
                      max-width: 100%;
                      margin-bottom: 16px;
                    }
                  }

                  > .right {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    padding-bottom: 0;

                    > div {
                      display: flex;
                      flex-direction: row;
                      gap: 12px;
                      color: #FFF;
                      padding: 0 15px;
                      > img {
                        width: 48px;
                        height: 48px;
                        margin-bottom: 0;
                      }
                      > div {
                        > strong {
                          font-weight: 700;
                          font-size: 12px;
                          line-height: 18px;
                          margin-bottom: 0;
                        }
                        > p {
                          display: none;
                          font-size: 11px;
                          line-height: 17px;
                          padding-right: 0;
                          &.mobile {
                            display: block;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            &:nth-child(4) {
              background-image: url("./images/Mobile-Header-bg-image-4.jpg");
              background-size: 770px;
              > .container {
                > .content {
                  flex-direction: column;
                  > .left {
                    width: 100%;
                    > img {
                      width: 187px;
                      margin-bottom: 14px;
                    }
                    > p {
                      font-size: 12px;
                      line-height: 20px;
                      margin-bottom: 12px;
                    }
                    > .buttons {
                      flex-direction: row;
                      flex-wrap: wrap;
                      gap: 4px;
                      > a {
                        width: 130px;
                        height: 35px;
                        font-size: 12px;
                        line-height: 18px;
                        > svg {
                          width: 8px;
                        }
                      }
                    }
                  }
                }
              }
            }

            > .container {
              z-index: 2;
              > .content {
                display: flex;
                justify-content: space-between;

                > .left {
                  padding: 0 10px;
                  > img {
                    margin-bottom: 12px;
                    max-width: 100%;
                  }

                  > p {
                    display: block;
                    font-family: Poppins;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 20px;
                    color: #FFF;
                    max-width: 100%;
                    margin-bottom: 40px;
                  }
                }

                > .right {
                  display: none;
                }
              }
            }
          }
        }
      }
      > .cta {
        gap: 16px;
        padding: 15px 0;
        > span {
          font-size: 13px;
          line-height: 13px;
        }
        > a.button {
          width: 157px;
          height: 40px;
          border-radius: 12px;
          font-size: 13px;
        }
      }
    }
  }
</style>
